










import { Component, Vue } from "vue-property-decorator";
// import { Action, Getter, Mutation } from "vuex-class";
import StaffForm from "@/components/sale/forms/StaffForm.vue";

@Component({
  components: { StaffForm },
})
export default class extends Vue {}
